const cliente = angular.module('cliente', [
    'core',
    'auth',
    'inicio',
    'produto',
    'acelerador',
    'comunidade',
    'partners',
    'ajuda',
    'usuario'
]);

cliente.config(['coreFbProvider', (coreFbProvider) => {
    coreFbProvider.firebaseConfig(APP_CONSTANTS.FIREBASE_CONFIG);
}])

cliente.config(['$stateProvider', '$urlServiceProvider', function($stateProvider, $urlServiceProvider) {

    const routes = [
        {
            name: 'cliente',
            url: '',
            redirectTo: 'cliente.inicio',
            component: 'layoutComponent',
            data: { requiresAuth: true }
        },
        {
            name: 'cliente.erro',
            url: '/erro',
            templateUrl: 'components/error/error.html',
            controller: ['$scope','coreLanguage', function($scope, $text){ $scope.$text = $text; }]
        },
        {
            name: 'cliente.erroPermissao',
            url: '/erroPermissao',
            templateUrl: 'components/error/permissao.html',
            controller: ['$scope','coreLanguage', function($scope, $text){ $scope.$text = $text; }]
        },
        {
            name: 'erroPermissao',
            redirectTo: 'cliente.erroPermissao',
        }
    ];

    routes.forEach($stateProvider.state);

    $urlServiceProvider.rules.otherwise({ state: 'cliente.erro', options: { location: false } });
}]);